var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticStyle:{"max-width":"120px","height":"auto"},attrs:{"src":"/logo.png","alt":"Vetnil"}})}
var staticRenderFns = []

export { render, staticRenderFns }